export enum UserRole {
  'USER' = 'USER',
  'ADMIN' = 'ADMIN',
  'SUPERADMIN' = 'SUPERADMIN',
  'OPERATOR' = 'OPERATOR',
  'DRIVER_MANAGER' = 'DRIVER_MANAGER',
}
